import { AbstractIndicatorCompanyStrategy, AbstractIndicatorStrategy } from "../../models/domains/pbm/indicators/abstract-indicator-strategy";
import { IIndicatorDataStrategy, IIndicatorData } from "../../models/domains/pbm/indicators/iindicator-data-strategy";
import { IndicatorService } from "../../services/pbm/indicator.service";
import { UserService } from "../../services/user.service";

export class BeneficiaryUsageIndicatorDataStrategy extends AbstractIndicatorStrategy implements IIndicatorDataStrategy {
  async processData(indicatorService: IndicatorService, userService: UserService): Promise<IIndicatorData> {
    return await super.doProcessData((s) => indicatorService.getBeneficiaryUsageData(s), userService);
  }
}

export class CompanySubsidiaryMonthlyBalanceIndicatorDataStrategy extends AbstractIndicatorCompanyStrategy implements IIndicatorDataStrategy {
  async processData(indicatorService: IndicatorService, userService: UserService): Promise<IIndicatorData> {
    return await super.doProcessData((s) => indicatorService.getCompanySubsidiaryMonthlyBalance(s), userService);
  }
}

export class MonthlyBalanceIndicatorDataStrategy extends AbstractIndicatorStrategy implements IIndicatorDataStrategy {
  async processData(indicatorService: IndicatorService, userService: UserService): Promise<IIndicatorData> {
    return await super.doProcessData((s) => indicatorService.getMonthlyBalance(s), userService);
  }
}

export class TopTenProductsIndicatorDataStrategy extends AbstractIndicatorStrategy implements IIndicatorDataStrategy {
  async processData(indicatorService: IndicatorService, userService: UserService): Promise<IIndicatorData> {
    return await super.doProcessData((s) => indicatorService.getTopTenProductsData(s), userService);
  }
}

export class ProductSubtypeIndicatorDataStrategy extends AbstractIndicatorStrategy implements IIndicatorDataStrategy {
  async processData(indicatorService: IndicatorService, userService: UserService): Promise<IIndicatorData> {
    return await super.doProcessData((s) => indicatorService.getProductSubtypeData(s), userService);
  }
}

export class TopTenNetworksIndicatorDataStrategy extends AbstractIndicatorStrategy implements IIndicatorDataStrategy {
  async processData(indicatorService: IndicatorService, userService: UserService): Promise<IIndicatorData> {
    return await super.doProcessData((s) => indicatorService.getTopTenNetworksData(s), userService);
  }
}

export class TopTenPractitionerIndicatorDataStrategy extends AbstractIndicatorStrategy implements IIndicatorDataStrategy {
  async processData(indicatorService: IndicatorService, userService: UserService): Promise<IIndicatorData> {
    return await super.doProcessData((s) => indicatorService.getTopTenPractitionerData(s), userService);
  }
}

export class TopTenTherapeuticClassIndicatorDataStrategy extends AbstractIndicatorStrategy implements IIndicatorDataStrategy {
  async processData(indicatorService: IndicatorService, userService: UserService): Promise<IIndicatorData> {
    return await super.doProcessData((s) => indicatorService.getTopTenTherapeuticClass(s), userService);
  }
}
